{
  "assetAdmin": {
    "forbidden": "Operation forbidden",
    "emailAlreadyInUse": "Email already in use",
    "phoneNumberAlreadyInUse": "Phone number already in use",
    "organizationNumberAlreadyInUse": "Customer organization business id already in use",
    "userGroupInUse": "User group already in use",
    "organizationNotFound": "Organization not found",
    "userGroupNotFound": "User group not found",
    "userNotFound": "User not found",
    "notAllowedParentOrganization": "{{parent}} can't be set as the parent company for {{child}}, because that would create a circular reference."
  },
  "productService": {
    "localeNotSupported": "Locale not supported"
  },
  "orderService": {
    "forbidden": "Operation forbidden"
  },
  "organization": {
    "fetchFailed": "Failed to fetch organization information"
  },
  "invoicingAccount": {
    "fetchFailed": "Fetching invoicing accounts failed"
  },
  "general": "Error: something went wrong"
}
